// generated from 54 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const attributedSourceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("attributed_source_filter"),
  comparison_key: z.enum([
    "1", // 48 (88.89%)
    "11", // 3 (5.56%)
    "12", // 2 (3.70%)
    "2", // 1 (1.85%)
  ]),
  display_name: z.string(),
  // undefined: 9 (16.67%), defined 45 (83.33%)
  raw_value: z.string().optional(),
  value: z.string(),
  varies_by_app_group: z.literal(true),
});
